module.exports = {
	url: '/galleries',
	template: require('raw!templates/galleries/galleries-view.html'),
	controller: GalleriesController,
	controllerAs: 'galleriesCtrl',
};

function GalleriesController($scope, $state, store, $window, contentful, $http, Socialshare) {
	var vm = this;
  $window.scrollTo(0, 0);
	contentful.entries('content_type=longPage&sys.id=4jqa7QAUcMGgK0ka2YUcYw&include6').then(function(res) {
		// console.log('gallery page contentful data',res);
		$scope.galleries = res.data.items[0];
		var seoData = res.data.items[0];
		if (seoData.fields.seoPageTitle) {
			document.title = seoData.fields.seoPageTitle;
		}
		if (seoData.fields.seoPageDescription) {
			var meta = document.getElementsByTagName("meta");
			for (var i = 0; i < meta.length; i++) {
				if (meta[i].name.toLowerCase() === "description") {
					meta[i].content = seoData.fields.seoPageDescription;
				}
			}
		}
	});
	contentful.entries('content_type=gallery&sys.id=73Fk6SaCGWEgKg4EgA4UOg').then(function(res) {
		console.log('room gallery data',res);
		$scope.roomGallery = res.data.items[0];
	});
	contentful.entries('content_type=gallery&sys.id=593jsONLB6w46omCMWsQAE').then(function(res) {
		console.log('amen gallery data',res);
		$scope.amenGallery = res.data.items[0];
	});
	contentful.entries('content_type=gallery&sys.id=3Xh8zGmrc4mG0WKGKKkE6M').then(function(res) {
		console.log('dining gallery data',res);
		$scope.eatGallery = res.data.items[0];
	});
	contentful.entries('content_type=gallery&sys.id=adMjMPfbHOOKaA8WcEssw').then(function(res) {
		console.log('meet gallery data',res);
		$scope.meetGallery = res.data.items[0];
	});

	vm.trustUrl = "trustUrl";

	trustUrl.$inject = ['$sce'];

	function trustUrl($sce) {
			return function (mediaUrl) {
				return $sce.trustAsResourceUrl(mediaUrl);
			};
		}
		$window.sr = ScrollReveal({ reset: true });
		sr.reveal('.home-load', { duration: 1000 });
		sr.reveal('#cafe', { distance: 0, duration: 1000, scale: 1.5 }, 500);
		sr.reveal('#pool', { distance: 0, duration: 1000, scale: 1.5 }, 500);
		sr.reveal('#king-suite', { distance: 0, duration: 1000, scale: 1.5 }, 500);
		sr.reveal('#meetings-events', { distance: 0, duration: 1000, scale: 1.5 }, 500);




	vm.socialShare = function(share) {
	if (share === 'facebook') {
		Socialshare.share({
			'provider': 'facebook',
			'attrs': {
				'socialshareUrl': 'http://peaks-hotel.herokuapp.com/galleries',
				'socialshareQuote': 'Peaks Hotel | Gallery',
				'socialshareMedia': 'https://peaks-hotel.herokuapp.com/images/_new assets/peaks-logo-social.png',
				'socialsharePopupHeight': '400',
				'socialsharePopupWidth': '400'
			}
		});
	} else if (share === 'twitter') {
		Socialshare.share({
			'provider': 'twitter',
			'attrs': {
				'socialshareUrl': 'http://peaks-hotel.herokuapp.com/galleries',
				'socialshareText': 'Peaks Hotel | Gallery',
				'socialshareMedia': 'https://peaks-hotel.herokuapp.com/images/_new assets/peaks-logo-social.png',
				'socialsharePopupHeight': '400',
				'socialsharePopupWidth': '400'
			}
		});
	} else if (share === 'pinterest') {
		Socialshare.share({
			'provider': 'pinterest',
			'attrs': {
				'socialshareUrl': 'http://peaks-hotel.herokuapp.com/galleries',
				'socialshareText': 'Peaks Hotel | Gallery',
				'socialshareMedia': 'https://peaks-hotel.herokuapp.com/images/_new assets/peaks-logo-social.png',
				'socialsharePopupHeight': '400',
				'socialsharePopupWidth': '400'
			}
		});
	} else if (share === 'email') {
		Socialshare.share({
			'provider': 'email',
			'attrs': {
				'socialshare-subject': 'Peaks Hotel | Gallery',
				'socialshare-body': 'Take a look at the Peaks Hotel!'
			}
		});
	}
}
}



// WEBPACK FOOTER //
// ./components/templates/galleries/galleries-controller.js